import React, { FunctionComponent } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { get, isEmpty, isNil } from 'lodash';
import { Grid, Card } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { FeeNote } from 'containers/LawyerFeeNote/typings';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import FeeNoteTable from 'containers/LawyerFeeNote/FeeNoteTable';
import CardTitle from 'containers/common/Card/CardTitle';
import styled from 'styled-components';
import warning from 'images/warning.svg';
import { getValueByCode as getValueByCodeSagis } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import {
  sumAllRegulationsCorpo,
  sumAllRegulationsSagis,
} from 'components/DialogFeeNote/utils';
import { Listings, SagisConfig } from 'containers/AppContainer/typings';
import { isDesactivateIntervenant } from 'services/utils';
import { COLORS } from 'constants/design';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import messages from 'containers/LawyerFeeNote/messages';
import { translate } from 'containers/services/translate';

const DialogTitle = (props: any) => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton}>
          <CloseIcon onClick={onClose} />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};
const StyledCard = {
  backgroundColor: COLORS.LIGHT_ORANGE,
  padding: '8px 16px 8px 8px',
  marginTop: '10px',
};
const StyledText = {
  color: COLORS.ORANGE_TEXT,
  fontSize: '14px',
  fontWeight: 500,
};
const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    width: '100%',
    height: '100%',
  },
}))(MuiDialogContent);
const DialogTitleStyled = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}))(DialogTitle);
const StyledDialog = styled(Dialog)`
  .MuiDialog-paperWidthSm {
    min-width: 1251px;
  }
`;
const DialogFeeNote: FunctionComponent<{
  intl: IntlShape;
  open: boolean;
  feeNotes: FeeNote[];
  feeNotesCount: number;
  requestCreateFeeNote: Function;
  requestFeeNoteCosts: Function;
  keyclokToken: string | null;
  uploadDocument: Function;
  requestLawyerFeeNotes: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadDocumentStore: Function;
  documentId: string;
  setDocumentId: Function;
  isManager?: boolean;
  status?: string;
  handleClose: Function;
  showButtonAdd: boolean;
  title: string;
  claimNumber: string;
  makeDecisionFeeNote?: Function;
  listings: Listings;
  requestAllFeeNotes: Function;
  allFeeNote: FeeNote[];
  page: number;
  setPage: Function;
  linkToBeneficiaryCodes?: SagisConfig[];
  isExpert: boolean;
  requestUpdateFeeNoteAmount: Function;
  loaders: any;
  requestAddInvoiceFeeNote: Function;
  requestUpdateInvoiceFeeNote: Function;
  contractorFeesSagis: any;
  requestUpdateFeeNoteStatus?: Function;
  isConsultation: boolean;
  requestUpdateFirmReferenceManager?: Function;
}> = (props): JSX.Element => {
  const renderListOfPaiedRegulation = () => {
    if (
      !isEmpty(
        sumAllRegulationsSagis(props.contractorFeesSagis, props.listings),
      ) &&
      isNil(props.keyclokToken) //for manager
    ) {
      return sumAllRegulationsSagis(props.contractorFeesSagis, props.listings);
    } else if (
      !isEmpty(sumAllRegulationsCorpo(props.feeNotes)) &&
      !isNil(props.keyclokToken) //for lawyer or expert
    ) {
      return sumAllRegulationsCorpo(props.feeNotes);
    } else {
      return [];
    }
  };
  const renderMessage = () => {
    return isNil(props.keyclokToken)
      ? messages.dialogTitle
      : messages.intervenantDialogTitle;
  };

  return (
    <div>
      <StyledDialog
        onClose={() => props.handleClose}
        aria-labelledby="customized-dialog-title"
        open={props.open}
      >
        <DialogTitleStyled onClose={props.handleClose}>
          <div className="header">
            <CardTitle count={props.feeNotesCount} message={props.title} />
          </div>
        </DialogTitleStyled>
        <DialogContent dividers>
          {featureService.hasFeature(FEATURES.EVOLUTIONS_FEE_NOTE) && (
            <>
              {renderListOfPaiedRegulation().map((el: any) => (
                <Card style={StyledCard} elevation={0}>
                  <Grid container direction="row" spacing={1}>
                    <Grid item>
                      <img src={warning} alt="warning" />
                    </Grid>
                    <Grid item xs={6}>
                      <Typography style={StyledText}>
                        {(isNil(props.keyclokToken)
                          ? isDesactivateIntervenant(
                              get(props.listings, 'intervenants'),
                              el.codeIntervenant,
                            )
                            ? translate(messages.inactiveTitle, props, {
                                LawyerName: getValueByCodeSagis(
                                  el.codeIntervenant,
                                  get(
                                    props.listings,
                                    'inactiveIntervenants',
                                    [],
                                  ),
                                ),
                              })
                            : getValueByCodeSagis(
                                el.codeIntervenant,
                                get(props.listings, 'intervenants'),
                              )
                          : '') +
                          translate(renderMessage(), props, {
                            sumSagisRegulations: el.sumSagisRegulations,
                          })}
                      </Typography>
                    </Grid>
                  </Grid>
                </Card>
              ))}
            </>
          )}
          <FeeNoteTable
            allFeeNotes={props.allFeeNote}
            requestAllFeeNotes={props.requestAllFeeNotes}
            feeNotes={
              props.isExpert
                ? props.feeNotes.filter(
                    element => !isEmpty(get(element, 'feeNoteMission', {})),
                  )
                : props.feeNotes
            }
            feeNotesCount={props.feeNotesCount}
            requestCreateFeeNote={props.requestCreateFeeNote}
            requestFeeNoteCosts={props.requestFeeNoteCosts}
            keyclokToken={props.keyclokToken}
            resetUploadDocumentStore={props.resetUploadDocumentStore}
            uploadDocument={props.uploadDocument}
            uploadedDocument={props.uploadedDocument}
            setDocumentId={props.setDocumentId}
            documentId={props.documentId}
            requestFeeNotes={props.requestLawyerFeeNotes}
            isManager={isNil(props.keyclokToken)}
            makeDecisionFeeNote={props.makeDecisionFeeNote}
            showButtonAdd={props.showButtonAdd}
            claimNumber={props.claimNumber}
            listings={props.listings}
            viewByClaim={true}
            page={props.page}
            setPage={props.setPage}
            linkToBeneficiaryCodes={props.linkToBeneficiaryCodes}
            requestUpdateFeeNoteAmount={props.requestUpdateFeeNoteAmount}
            requestUpdateFeeNoteStatus={props.requestUpdateFeeNoteStatus}
            requestManagerAllFeeNotes={() => {}}
            loaders={props.loaders}
            requestAddInvoiceFeeNote={props.requestAddInvoiceFeeNote}
            requestUpdateInvoiceFeeNote={props.requestUpdateInvoiceFeeNote}
            isConsultation={props.isConsultation}
            requestUpdateFirmReferenceManager={
              props.requestUpdateFirmReferenceManager
            }
          />
        </DialogContent>
      </StyledDialog>
    </div>
  );
};
export default injectIntl(DialogFeeNote);
